import React, { useEffect, useState } from 'react';
import { Megaphone, Plus, Trash2, X } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useT } from '../context/LanguageContext';
import { inputCls } from './admin/EditorShell';

const fmt = (iso) => { const d = new Date(iso); return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`; };

const Updates = () => {
  const { user } = useAuth();
  const { t } = useT();
  const [items, setItems] = useState([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ title: '', text: '' });

  useEffect(() => { api.get('/updates').then((r) => setItems(r.data)).catch(() => {}); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/admin/updates', form);
      setItems([data, ...items]); setForm({ title: '', text: '' }); setAdding(false); toast.success('Oppdateringa er publisert');
    } catch (err) { toast.error(formatApiError(err)); }
  };
  const remove = async (id) => {
    if (!window.confirm('Slette oppdateringa?')) return;
    try { await api.delete(`/admin/updates/${id}`); setItems(items.filter((u) => u.id !== id)); } catch (err) { toast.error(formatApiError(err)); }
  };

  if (items.length === 0 && !user?.is_admin) return null;

  return (
    <div className="mt-12 md:mt-16 max-w-3xl" data-testid="updates-section">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="text-white/50 font-bold uppercase tracking-widest text-xs inline-flex items-center gap-2"><Megaphone size={14} className="text-[#ff2e2e]" /> {t('Oppdateringar')}</p>
        {user?.is_admin && !adding && <button type="button" onClick={() => setAdding(true)} data-testid="updates-add-button" className="inline-flex items-center gap-1 text-xs font-bold text-[#ffb400] hover:underline"><Plus size={14} /> Ny oppdatering</button>}
      </div>
      {adding && (
        <form onSubmit={add} className="rounded-2xl border border-[#ffb400]/40 bg-[#ffb400]/5 p-4 mb-3 space-y-2" data-testid="updates-form">
          <input className={inputCls} placeholder="Tittel" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required maxLength={100} data-testid="updates-title-input" />
          <textarea className={`${inputCls} resize-y`} rows={2} placeholder="Kort tekst (valfritt)" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} maxLength={600} data-testid="updates-text-input" />
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setAdding(false)} className="px-4 py-2 rounded-full border border-white/15 text-white text-sm">Avbryt</button>
            <button type="submit" data-testid="updates-submit-button" className="px-5 py-2 rounded-full bg-[#ffb400] text-black text-sm font-bold">Publiser</button>
          </div>
        </form>
      )}
      <div className="rounded-2xl bg-[#120c1b] border border-white/5 divide-y divide-white/5 max-h-56 overflow-y-auto">
        {items.length === 0 && <p className="px-4 py-3 text-white/35 text-sm">Ingen oppdateringar enno.</p>}
        {items.map((u) => (
          <div key={u.id} className="px-4 py-3 flex items-start gap-3" data-testid={`update-${u.id}`}>
            <span className="text-[#ff2e2e] text-[11px] font-bold tabular-nums mt-0.5 shrink-0">{fmt(u.created_at)}</span>
            <div className="flex-1 min-w-0">
              <p className="text-white font-bold text-sm leading-tight">{u.title}</p>
              {u.text && <p className="text-white/60 text-sm leading-snug mt-0.5">{u.text}</p>}
            </div>
            {user?.is_admin && <button type="button" onClick={() => remove(u.id)} aria-label="Slett" data-testid={`update-delete-${u.id}`} className="text-white/30 hover:text-red-400"><Trash2 size={14} /></button>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Updates;
